import React from "react";
import { Me } from "../../assets/icons";

interface iProps extends React.HTMLProps<HTMLDivElement> {}

const AboutMe: React.FC<iProps> = (props) => {
  return (
    <div
      className="flex items-center py-8 gap-4 tablet:flex-col tablet:justify-start tablet:items-center"
      id="aboutMeId"
    >
      <div>
        <Me />
      </div>
      <div className="flex flex-col px-4 ">
        <p>Hello I'm </p>
        <div className="typewriter w-fit">
          <h1 className="font-medium text-xl text-primary w-fit ">
            Duy Nha Tran
          </h1>
        </div>
        <div className="border-r-2 w-fit border-primary font-semibold text-3xl py-2">
          I'm a Software Engineer
        </div>
        <p>
          Currently, I'm a HTM5 and Js Developer at{" "}
          <span className="text-[#c1d82f]">Nexon Dev Vina</span>.
        </p>
        <p className="mt-2">
          I'm from
          <span className="text-secondary font-bold "> HCMUTE</span>. I have
          nearly 4 years of experience as a Frontend Developer.. So I believe I
          have enough experience to meet your needs.
        </p>
        <p className=" mt-2">
          This is my resume link, click{" "}
          <a
            className="text-secondary underline font-bold"
            href="https://www.topcv.vn/xem-cv/VQkHAAdTVFJWBltSDwUEUFUDCgUCVg1SXQVTAAf142"
            target="_blank"
            rel="noreferrer"
          >
            here to view
          </a>{" "}
          or ask my{" "}
          <a href="#assistantId" className="text-primary underline font-bold">
            Assistant
          </a>{" "}
          below.
        </p>
      </div>
    </div>
  );
};
export default AboutMe;
